module.exports = __webpack_public_path__ + "assets/img/gl_icon.ec7439ac.png";